var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"fill-height pt-12 mt-4",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"display-2-responsive font-weight-thin",attrs:{"cols":"12","md":"10","lg":"8"}},[_vm._t("default")],2),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }